import React from "react";

import ExistingProjectList from "./list";

import { useDocumentTitle } from "$utils/document-title";
import { getTerm } from "$stores/dictionary";

const ExistingProjects = () => {
    useDocumentTitle(`${getTerm("existingProjects")} List`);

    return (
        <div>
            <ExistingProjectList />
        </div>
    );
};

export default ExistingProjects;
